export class AuditableRowModel {
    name: string;
    createdByUser: number;
    createdDate: Date;
    modifiedByUser: number;
    modifiedDate: Date;
    selected: boolean;
}
